























































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import Accordion from '@/components/Accordion.vue';
import SearchIcon from 'mdi-vue/Magnify';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import FormInput from '@/components/FormInput.vue';
import Loader from '@/components/Loader.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import Checkbox from '@/components/Checkbox.vue';
import { MerchantsManagement, MerchantChannel, User } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import Modal from '@/components/Modal.vue';
import numberFormat from '@/libs/numberFormat';
import Button from '@/components/Button.vue';
import AddIcon from 'mdi-vue/Plus';
import Pagination from '@/components/Pagination.vue';
import Select from '@/components/Select.vue';
import Select2 from '@/components/Select2.vue';
import CloseIcon from 'mdi-vue/Close';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import { mapState } from 'vuex';
import Alto from '../../AccountManagement/Edit/Form/Alto.vue';
import BayarindWeb from '../../AccountManagement/Edit/Form/BayarindWeb.vue';
import BcaKlikPay from '../../AccountManagement/Edit/Form/BcaKlikPay.vue';
import BcaSakuku from '../../AccountManagement/Edit/Form/BcaSakuku.vue';
import BcaVirtualAccount from '../../AccountManagement/Edit/Form/BcaVirtualAccount.vue';
import BniIpay from '../../AccountManagement/Edit/Form/BniIpay.vue';
import BniSyariahVirtualAccount from '../../AccountManagement/Edit/Form/BniSyariahVirtualAccount.vue';
import BniVirtualAccount from '../../AccountManagement/Edit/Form/BniVirtualAccount.vue';
import BPDPay from '../../AccountManagement/Edit/Form/BPDPay.vue';
import BriePay from '../../AccountManagement/Edit/Form/BriePay.vue';
import BriVirtualAccount from '../../AccountManagement/Edit/Form/BriVirtualAccount.vue';
import CIMBClick from '../../AccountManagement/Edit/Form/CIMBClick.vue';
import DANA from '../../AccountManagement/Edit/Form/DANA.vue';
import DanamonVirtualAccount from '../../AccountManagement/Edit/Form/DanamonVirtualAccount.vue';
import Indodana from '../../AccountManagement/Edit/Form/Indodana.vue';
import IndosatDompetku from '../../AccountManagement/Edit/Form/IndosatDompetku.vue';
import KartuKredit from '../../AccountManagement/Edit/Form/KartuKredit(DoAcquire).vue';
import KlikBCA from '../../AccountManagement/Edit/Form/KlikBCA.vue';
import Kredivo from '../../AccountManagement/Edit/Form/Kredivo.vue';
import MandiriClickPay from '../../AccountManagement/Edit/Form/MandiriClickPay.vue';
import MandirieCash from '../../AccountManagement/Edit/Form/MandirieCash.vue';
import MandiriVirtualAccount from '../../AccountManagement/Edit/Form/MandiriVirtualAccount.vue';
import Maybank2You from '../../AccountManagement/Edit/Form/Maybank2You.vue';
import MaybankVirtualAccount from '../../AccountManagement/Edit/Form/MaybankVirtualAccount.vue';
import PermataVirtualAccount from '../../AccountManagement/Edit/Form/PermataVirtualAccount.vue';
import ShopeePay from '../../AccountManagement/Edit/Form/ShopeePay.vue';
import TCash from '../../AccountManagement/Edit/Form/TCash.vue';
import UnionPay from '../../AccountManagement/Edit/Form/UnionPay.vue';
import ArtaGrahaVirtualAccount from '../../AccountManagement/Edit/Form/ArtaGrahaVirtualAccount.vue';
import Atome from '../../AccountManagement/Edit/Form/Atome.vue';
import BncVirtualAccount from '../../AccountManagement/Edit/Form/BncVirtualAccount.vue';
import Ovo from '../../AccountManagement/Edit/Form/Ovo.vue';
import Alfamart from '../../AccountManagement/Edit/Form/Alfamart.vue';
import AEON from '../../AccountManagement/Edit/Form/AEON.vue';
import Blu from '../../AccountManagement/Edit/Form/Blu.vue';
import BtnVirtualAccount from '../../AccountManagement/Edit/Form/BtnVirtualAccount.vue';
import Qris from '../../AccountManagement/Edit/Form/Qris.vue';
import ModalPricing from '../../AccountManagement/Edit/ModalPricing.vue';
import PaymentChannelSetting from './PaymentChannelSetting.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    ModalPricing,
    SearchField,
    Select,
    TagInput,
    Table,
    AddIcon,
    SearchIcon,
    Select2,
    TableBody,
    Accordion,
    Row,
    Header,
    Cell,
    Button,
    Pagination,
    FormInput,
    ActionPopup,
    ScrollbarWrapper,
    Modal,
    CloseIcon,
    Checkbox,
    Alto,
    BayarindWeb,
    BcaKlikPay,
    BcaSakuku,
    BcaVirtualAccount,
    BniIpay,
    BniSyariahVirtualAccount,
    BniVirtualAccount,
    BPDPay,
    BriePay,
    BriVirtualAccount,
    CIMBClick,
    DANA,
    DanamonVirtualAccount,
    Indodana,
    IndosatDompetku,
    KartuKredit,
    KlikBCA,
    Kredivo,
    MandiriClickPay,
    MandirieCash,
    MandiriVirtualAccount,
    Maybank2You,
    MaybankVirtualAccount,
    PermataVirtualAccount,
    ShopeePay,
    TCash,
    UnionPay,
    ArtaGrahaVirtualAccount,
    PaymentChannelSetting,
    Qris,
  },
  methods: {
    numberFormat,
  },
  computed: mapState(['user']),
})
export default class ReportDetail extends Vue {
  loading = false;
  isSetting = false;
  isProduction = false;
  user!: {
    user: User;
  };

  // eslint-disable-next-line spaced-comment
  channelCodes: { [key: string]: string[] } = {
    // 1072: ['Alto', 'Alto'],
    1022: ['BCA KlikPay', 'BcaKlikPay'],
    1024: ['BCA Sakuku', 'BcaSakuku'],
    1021: ['BCA Virtual Account', 'BcaVirtualAccount'],
    1041: ['BNI iPay', 'BniIpay'],
    1042: ['BNI Virtual Account', 'BniVirtualAccount'],
    1043: ['BNI Syariah Virtual Account', 'BniSyariahVirtualAccount'],
    1062: ['BRI Virtual Account', 'BriVirtualAccount'],
    1081: ['Octo Click', 'CIMBClick'],
    1074: ['Danamon Virtual Account', 'DanamonVirtualAccount'],
    1061: ['BRIMO', 'BriePay'],
    // 1071: ['Indosat Dompetku', 'IndosatDompetku'],
    2001: ['Kartu Kredit (DoAcquire)', 'KartuKredit'],
    2002: ['Kartu Kredit (PCS)', 'KartuKreditPCS'],
    1023: ['KlikBCA', 'KlikBCA'],
    1073: ['Kredivo', 'Kredivo'],
    // 1031: ['Mandiri eCash', 'MandirieCash'],
    1032: ['Mandiri Bill Payment', 'MandiriVirtualAccount'],
    // 1051: ['Maybank 2 you', 'Maybank2You'],
    1052: ['Maybank Virtual Account', 'MaybankVirtualAccount'],
    1011: ['Permata Virtual Account/Net', 'PermataVirtualAccount'],
    // 9999: ['Mandiri ClickPay', 'MandiriClickPay'],
    1077: ['TCASH', 'TCash'],
    // 9998: ['BPDPay', 'BPDPay'],
    // 1082: ['UnionPay', 'UnionPay'],
    1080: ['Indodana', 'Indodana'],
    1083: ['Bayarind Web', 'BayarindWeb'],
    1084: ['DANA', 'DANA'],
    1085: ['ShopeePay', 'ShopeePay'],
    1078: ['Homecredit', 'Homecredit'],
    9001: ['Onepay', 'Onepay'],
    9002: ['Easy Invoice', 'Easyinvoice'],
    1101: ['Arta Graha Virtual Account', 'ArtaGrahaVirtualAccount'],
    1012: ['Permata Net', 'PermataVirtualAccount'],
    1088: ['Atome', 'Atome'],
    1090: ['BNC Virtual Account', 'BncVirtualAccount'],
    1086: ['OVO', 'Ovo'],
    1087: ['Alfamart', 'Alfamart'],
    1091: ['AEON', 'AEON'],
    1026: ['Blu', 'Blu'],
    1092: ['BTN Virtual Account', 'BtnVirtualAccount'],
    1089: ['QRIS', 'Qris'],
  }

  listChannel: string[] = [];
  listComponent: { [key: string]: string } = {};
  bankData = {
    sandbox: [],
    production: [],
  };

  secretKey = {
    sandbox: '',
    production: '',
  };

  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  loadingPage = true;

  paymentChannel = [];
  paymentChannels: any = [];
  isAddPaymentChannel = false;
  editedChannel = '';
  // scChannelID = '';

  showProduction = true;
  showSandbox = true;

  channel = '';
  channelWhenOpened = '';
  channelComponent = '';
  autoGenerate = true;
  showSelect = false;
  mcode = '';
  channelInput = '';
  serviceCode = '';
  credentials = '';
  channelID = '';
  title = '';
  showModal = false;
  data!: MerchantsManagement;
  // channellist: MerchantsManagement[] = [];
  channellist: MerchantChannel[] = [];
  merchantPaymentChannel: any[] = [];
  numberFormat!: typeof numberFormat;

  @Watch('channel')
  onChannelChange() {
    this.channelComponent = this.listComponent[this.channel];
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
    this.getChannel();
  }

  async openDetail(id: number, bID: string) {
    this.channelID = bID;
    // this.scChannelID = bID;
    this.showModal = true;
    this.isSetting = false;
    this.showProduction = true;
    this.showSandbox = true;
    this.isAddPaymentChannel = false;
    const [channelName, channelComponent] = this.channelCodes[id.toString()];
    this.editedChannel = channelName;
    this.channelComponent = channelComponent;
    this.serviceCode = id.toString();
  }

  async settingDetail(data: any) {
    if (data.service_code === '1021' || data.service_code === '1022') {
      this.credentials = data.credentials;
    } else {
      this.credentials = data.channel_id;
    }
    this.channelID = data.channel_id;
    this.title = data.service_name;
    this.isSetting = true;
    this.showModal = true;
    this.isAddPaymentChannel = false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // sclose(val: any) {
  //   this.IsModalPricing = val;
  // }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    return dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  }

  // eslint-disable-next-line class-methods-use-this
  translateServiceCode(serviceCode: number) {
    if (this.channelCodes[serviceCode] === undefined) {
      return '-';
    }
    const [channel, _] = this.channelCodes[serviceCode];
    return channel;
  }

  closeModal() {
    this.showModal = false;
  }

  async checkChannel() {
    try {
      await api.post('/merchant/channel/check', {
        // eslint-disable-next-line @typescript-eslint/camelcase
        channel_id: this.channelInput,
      });
      this.showSelect = true;
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', err.response.data.error.errors[0].message);
      this.loading = false;
    }
  }

  @Watch('autoGenerate')
  toggleShow() {
    if (this.autoGenerate === true) {
      this.showSelect = true;
      this.channelInput = '';
    } else {
      this.showSelect = false;
    }
  }

  async addPaymentChannel() {
    this.showModal = true;
    this.paymentChannel = [];
    this.isAddPaymentChannel = true;

    const { data } = await api.get('listPaymentChannel');

    this.paymentChannels = Object.entries(data).map((d: any) => d[1])
      /* eslint-disable arrow-body-style */
      .flat()
      .map((e: any) => {
        return {
          label: e.name,
          value: e.service_code,
        };
      });
    console.log(this.paymentChannels);
  }

  async getMerchant() {
    const id = JSON.parse(localStorage.getItem('USER') || '{}');

    try {
      this.loading = true;
      const { data } = await apiSandbox.get(`consumer/channel/${id.merchant.merchant_code}`);
      this.data = data;
      this.mcode = data.merchant_code;
      this.getChannel();
    } catch (err) {
      console.error(err);
      showToast(
        ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`,
        'Failed to get transaction detail',
      );
    }
  }

  async getChannel() {
    const id = JSON.parse(localStorage.getItem('USER') || '{}');

    try {
      this.loadingPage = true;
      const { data } = await apiSandbox.get(`consumer/channel/${id.user.merchant.merchant_code}`, {
        params: {
          page: this.page,
        },
      });
      this.mcode = data.merchant_code;
      this.merchantPaymentChannel = data.payment_list.data;
      // this.page = data.;
      this.totalPage = Math.ceil(data.payment_list.total / data.payment_list.per_page);
      this.from = data.payment_list.from;
      this.to = data.payment_list.to;
      this.totalItem = data.payment_list.total;
      this.loading = false;
      this.loadingPage = false;
    } catch (err) {
      console.error(err);
      showToast(
        ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`,
        'Failed to get transaction detail',
      );

      this.loading = false;
      this.loadingPage = false;
    }
  }

  async requestPaymentChannel() {
    try {
      const code: any = [];
      this.paymentChannel.map((e: any) => (code.push(e.value)));

      await apiSandbox.post('merchant/payment-channel', {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: this.$route.params.type,
        service_code: code,
      });
      showToast(ToastType.SUCCESS, 'Success Create Channel', 'Congrats, your changes have been saved');
      this.close(false);
    } catch (error) {
      showToast(ToastType.FAILED, 'Error', error.response.data.messsage);
    }
  }

  async mounted() {
    if (process.env.VUE_APP_ENVIRONMENT === 'production') {
      this.isProduction = true;

      if (this.user.user.merchant.status === 'INACTIVE') {
        this.$router.replace('/dashboard');
      }
    }
    const page = new URL(window.location.href).searchParams.get('page');
    if (typeof page === 'string' && parseInt(page, 10) > 0) {
      this.page = parseInt(page, 10);
    }
    this.toggleShow();
    this.loading = true;
    this.getChannel();
    await this.getBankData();

    const { channels, components } = Object.entries(this.channelCodes).reduce((prev, curr) => {
      const last = prev;
      const [code, comp] = curr[1];
      last.channels.push(code);
      last.components[code] = comp;

      return last;
    }, {
      channels: [] as string[],
      components: {} as { [key: string]: string },
    });

    this.listChannel = channels;
    this.listComponent = components;
    this.loading = false;
  }

  // eslint-disable-next-line class-methods-use-this
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(val: any) {
    this.channel = '';
    this.showModal = val;
    // this.getChannel();
  }

  exitComponent(phase: string) {
    if (phase === 'production') {
      this.showProduction = false;
    } else {
      this.showSandbox = false;
    }
  }

  showComponent(phase: string) {
    if (phase === 'production') {
      this.channelID = '';
      this.showProduction = true;
    } else {
      this.channelID = '';
      this.showSandbox = true;
    }
  }

  async getBankData() {
    try {
      // this.trafficAverage = '';
      await apiSandbox.get('/merchant/channel/detail').then(({ data }) => {
        // console.log(data);
        this.bankData.sandbox = data.merchant_channel;
        this.secretKey.sandbox = data.secret_key;
      });
      await apiProduction.get('/merchant/channel/detail').then(({ data }) => {
        // console.log(data);
        this.bankData.production = data.merchant_channel;
        this.secretKey.production = data.secret_key;
      });
    } catch (err) {
      console.error(err);
    }
  }

  get itemData() {
    let channelSandbox: any = this.bankData.sandbox?.filter((val: any) => val.service_code === this.serviceCode)[0] || {};
    console.log('channelSandbox', channelSandbox);
    if (channelSandbox.channels) {
      channelSandbox = channelSandbox.channels.filter((val: any) => val.channel_id === this.channelID);
    }
    let channelProduction: any = this.bankData.production?.filter((val: any) => val.service_code === this.serviceCode)[0] || {};
    if (channelProduction.channels) {
      channelProduction = channelProduction.channels.filter((val: any) => val.channel_id === this.channelID);
    }
    const result: any = {
      sandbox: channelSandbox[0] || {},
      production: channelProduction[0] || {},
    };
    result.sandbox.disableEdit = true;
    result.production.disableEdit = true;
    return { ...result };
  }
}
